/** Stored at Firestore `config/app`. */
export type AppConfig = {
  version?: number;
};

export const locales = ["fr", "en", "nl", "de", "es"] as const;
export type Locales = typeof locales;
export type Locale = (typeof locales)[number];
